import React, { useLayoutEffect, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as amplitude from '@amplitude/unified';
import { useAuth } from '../contexts/AuthContext';
import { usePageTracking } from '../hooks/usePageTracking';
import { scrollAppToTop } from '../utils/scroll-app-main';
import { ImpersonationBanner } from './ImpersonationBanner';
import { HeaderPageActionsProvider } from './HeaderPageActions';

export const AppWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
  const { originalAdminUser, user } = useAuth();
  usePageTracking();

  useLayoutEffect(() => {
    scrollAppToTop();
  }, [pathname]);

  useEffect(() => {
    if (!import.meta.env.VITE_AMPLITUDE_API_KEY) {
      return;
    }
    amplitude.setOptOut(!!originalAdminUser);
  }, [originalAdminUser]);

  useEffect(() => {
    if (!import.meta.env.VITE_AMPLITUDE_API_KEY) {
      return;
    }
    if (user) {
      amplitude.setUserId(user.id);
      const identifyEvent = new amplitude.Identify();
      identifyEvent.set('email', user.email);
      identifyEvent.set('plan', user.tier);
      identifyEvent.set('locale', user.preferredLanguageCode);
      identifyEvent.set('signup_date', user.createdAt);
      amplitude.identify(identifyEvent);
    } else {
      amplitude.setUserId(undefined);
    }
  }, [user?.id]);

  return (
    <div className="app-shell">
      <ImpersonationBanner />
      <div className="app-shell-main">
        <HeaderPageActionsProvider>
          {children}
        </HeaderPageActionsProvider>
      </div>
    </div>
  );
};
